import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Filtros from "@Composicion/Filtros/Filtros";

import "./MRestablecerForm.css";
function MRestablecerForm({ registro, fCerrarComponente }) {
  const origenComponente = "MRestablecerForm";
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},
    //FORM
    form: [],
    datosForm: {},
    existeToken: false,
    mensajeFormulario: "",
  });

  const [actualizaDatosTabla, setactualizaDatosTabla] = useState(null);

  useEffect(() => {
    console.log(registro);
    const contraseniaRestablecerAPI = _api_.f_contraseniaRestablecer({
      parametros: {
        modo: "DSF",
        codigo: registro?.codigo ?? "",
        contrasenia: "",
        recontrasenia: "",
      },
      timeout: 5000,
      origen: origenComponente,
    });
    contraseniaRestablecerAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          form: dPC.contenido?.form ?? [],
          existeToken: dPC.contenido?.token ?? false,
          mensajeFormulario: dPC.contenido?.mensaje ?? "",
        });
      }
    });
  }, []);
  return (
    <div className={"MRestablecerFormCSS-contenedor"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false, errores_mostrar: false });
          }}
        >
          {v_c.errores_mostrar && (
            <_lul_.ListaUL
              texto={v_c.modal_mensaje}
              listaElementos={v_c.errores_lista}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={`Se restableció correctamente la contraseña de: ${registro.Nombres}`}
              fBotonDeAcuerdo={() => {
                fCerrarComponente?.();
              }}
            ></_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <_div_.Div
        texto={`
        ${v_u.existeToken ? v_u.mensajeFormulario : "Debe generar un token para restablecer la contraseña de: "}
        ${registro.Nombres}`}
      />
      <_form_.Formulario
        form={v_u.form ?? []}
        dext={setactualizaDatosTabla}
        onBlurCampos={{}}
        fObtenerDatosFormulario={(datos) => {
          _f_.asignar(ev_u, { datosForm: datos });
        }}
      ></_form_.Formulario>

      <div className="MRestablecerFormCSS-opciones">
        <_btn_.Boton
          disabled={!v_u.existeToken}
          texto="Aceptar"
          tipo="btn-2"
          estilos={{ anchoB2: "5rem", color: "#4e942e" }}
          onClick={() => {
            console.log("enre a aceptar", v_u.datosForm);
            const restablecerContraseniaAPI = _api_.f_contraseniaRestablecer({
              parametros: {
                modo: "UPD",
                codigo: registro?.codigo ?? "",
                contrasenia: v_u.datosForm.con,
                recontrasenia: v_u.datosForm.recon,
              },
              timeout: 5000,
              origen: origenComponente,
            });
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "⏳ Procesando",
              procesandoAccion_mostrar: true,
            });
            restablecerContraseniaAPI.respuesta.then((dPC) => {
              _f_.asignar(ecv_u, dPC, true, origenComponente);

              // console.log(dPC);
              if (!dPC.error) {
                _f_.asignar(ev_c, {
                  procesandoAccion_mostrar: false,
                  modal_titulo: "✅ Éxito",
                  postConfirmar_mostrar: true,
                });
              }
            });
          }}
        />
        <_btn_.Boton
          disabled={v_u.existeToken}
          texto="Generar Token"
          tipo="btn-2"
          estilos={{ anchoB2: "10rem", color: "#c29f3f" }}
          onClick={() => {
            const generarTokenAPI = _api_.f_restablecerContrasenia({
              parametros: { codigoUsuario: registro?.codigo },
              timeout: 5000,
              origen: origenComponente,
            });
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "⏳ Procesando",
              procesandoAccion_mostrar: true,
            });
            generarTokenAPI.respuesta.then((dPC) => {
              _f_.asignar(ecv_u, dPC, true, origenComponente);
              console.log(dPC);
              if (!dPC.error) {
                _f_.asignar(ev_u, {
                  existeToken: dPC.contenido?.tokenDeSeguridad ?? false,
                  mensajeFormulario: "Ingrese la nueva contraseña para: " ?? "",
                });
                _f_.asignar(ev_c, {
                  modal_mostrar: false,
                  modal_titulo: "",
                  procesandoAccion_mostrar: false,
                });
              }
            });
          }}
        />
      </div>
    </div>
  );
}
export default MRestablecerForm;
